import React, { useEffect, useState } from "react";
import { useLocation, Link } from "react-router-dom";
import NavLink from "../components/NavLink";
import { ChartLine, FlagBanner } from "@phosphor-icons/react";
import { User, Key, LogOut } from 'feather-icons-react';

const sidebarData = [
  {
    commonUrl: "/dashboard",
    primary: {
      iconClass: <ChartLine size={18} />,
      title: "Dashboard",
      url: "/dashboard",
    },
  },
  {
    commonUrl: "/user",
    primary: {
      iconClass: <FlagBanner size={18} />,
      title: "Customers",
      url: "/user",
    },
  },
  {

    primary: {
      iconClass: <FlagBanner size={18} />,
      title: "Reports",
      
    },
    secondary: [
      {
        title: "Revenue Report",
        url: "/reports/revenue",
      },
      {
        title: "Order Report",
        url: "/reports/order",
      },
      {
        title: "Package Report",
        url: "/reports/package",
      },
      {
        title: "Temple Report",
        url: "/reports/temple",
      },
    ],
  },
  {
    commonUrl: "/temples",
    primary: {
      iconClass: <FlagBanner size={18} />,
      title: "Temples",
      url: "/temples",
    },
  },
  {
    commonUrl: "/packages",
    primary: {
      iconClass: <FlagBanner size={18} />,
      title: "Packages",
      url: "/packages",
    },
  },
  {
    commonUrl: "/email",
    primary: {
      iconClass: <FlagBanner size={18} />,
      title: "Email",
      url: "/email",
    },
  },  {
    commonUrl: "/subscribers",
    primary: {
      iconClass: <FlagBanner size={18} />,
      title: "Subscribers",
      url: "/subscribers",
    },
  },
  // {
  //   commonUrl: "/reports",
  //   primary: {
  //     iconClass: <FlagBanner size={18} />,
  //     title: "Report",
  //     url: "/reports",
  //   },
  // },
  {
    commonUrl: "/pricing/form",
    primary: {
      iconClass: <FlagBanner size={18} />,
      title: "Price Module",
      url: "/pricing/form",
    },
  },

  {
    commonUrl: "/trending-temples",
    primary: {
      iconClass: <FlagBanner size={18} />,
      title: "Trending Temples",
      url: "/trending-temples",
    },
  },

  {
    commonUrl: "/homepage-banner",
    primary: {
      iconClass: <FlagBanner size={18} />,
      title: "Home Page Banner",
      url: "/homepage-banner",
    },
  },

  {
    commonUrl: "/customer-shared",
    primary: {
      iconClass: <FlagBanner size={18} />,
      title: "Customer Shared",
      url: "/customer-shared",
    },
  },
  {
    commonUrl: "/payment-history",
    primary: {
      iconClass: <FlagBanner size={18} />,
      title: "Payment History",
      url: "/payment-history",
    },
  },{
    commonUrl: "/cart",
    primary: {
      iconClass: <FlagBanner size={18} />,
      title: "Default Trip Bookings",
      url: "/cart",
    },
  },
  {
    commonUrl: "/customize-cart",
    primary: {
      iconClass: <FlagBanner size={18} />,
      title: "Customised Trip Bookings",
      url: "/customize-cart",
    },
  },
  {
    commonUrl: "/customize-pricing",
    primary: {
      iconClass: <FlagBanner size={18} />,
      title: "Customize Pricing",
      url: "/customize-pricing",
    },
  },
  {
    commonUrl: "/customize-location",
    primary: {
      iconClass: <FlagBanner size={18} />,
      title: "Customize Location",
      url: "/customize-location",
    },
  },
  {
    commonUrl: "/pickup-point",
    primary: {
      iconClass: <FlagBanner size={18} />,
      title: "Pickup Point",
      url: "/pickup-point",
    },
  },
  {
    commonUrl: "/pickup-time",
    primary: {
      iconClass: <FlagBanner size={18} />,
      title: "Pickup Time",
      url: "/pickup-time",
    },
  },
  {
    commonUrl: "/drop-point",
    primary: {
      iconClass: <FlagBanner size={18} />,
      title: "Drop Point",
      url: "/drop-point",
    },
  },
  {
    commonUrl: "/contact-us",
    primary: {
      iconClass: <FlagBanner size={18} />,
      title: "Contact Us",
      url: "/contact-us",
    },
  },
  {
    commonUrl: "/faq-topic",
    primary: {
      iconClass: <FlagBanner size={18} />,
      title: "Faq Topic",
      url: "/faq-topic",
    },
  },
  {
    commonUrl: "/faq-sub-topic",
    primary: {
      iconClass: <FlagBanner size={18} />,
      title: "Faq Sub-Topic",
      url: "/faq-sub-topic",
    },
  },
  {
    commonUrl: "/faq-answer",
    primary: {
      iconClass: <FlagBanner size={18} />,
      title: "Faq Answer",
      url: "/faq-answer",
    },
  },
  {
    commonUrl: "/default-review",
    primary: {
      iconClass: <FlagBanner size={18} />,
      title: "Default Package Review",
      url: "/default-review",
    },  
  },
  {
    commonUrl: "/customize-review",
    primary: {
      iconClass: <FlagBanner size={18} />,
      title: "Customize Package Review",
      url: "/customize-review",
    },
  }, {
    commonUrl: "/terms-&-condition",
    primary: {
      iconClass: <FlagBanner size={18} />,
      title: "Terms And Condition",
      url: "/terms-&-condition",
    },
  },
  {
    commonUrl: "/privacy-policy",
    primary: {
      iconClass: <FlagBanner size={18} />,
      title: "Privacy And Policy",
      url: "/privacy-policy",
    },
  },
  // {
  //   commonUrl: "/customer/shared-photos",
  //   primary: {
  //     iconClass: <FlagBanner size={18} />,
  //     title: "Customer Shared Photos",
  //     url: "/customer/shared-photos",
  //   },
  // }
];

const Sidebar = () => {
  const location = useLocation();
  const [showProfileSubmenu, setShowProfileSubmenu] = useState(false);

  const isPathActive = (path) => {
    return location.pathname.startsWith(path);
  };

  useEffect(() => {
    const body = document.querySelector("body");
    document.querySelectorAll(".sidebar .nav-item").forEach((el) => {
      el.addEventListener("mouseover", () => {
        if (body.classList.contains("sidebar-icon-only")) {
          el.classList.add("hover-open");
        }
      });
      el.addEventListener("mouseout", () => {
        if (body.classList.contains("sidebar-icon-only")) {
          el.classList.remove("hover-open");
        }
      });
    });

    return () => {
      // Clean up event listeners if needed
    };
  }, [location]);

  return (
    <nav className="sidebar sidebar-offcanvas" id="sidebar">
    <ul className="nav">
      {sidebarData.map((data) => {
        return (
          <NavLink
            isPathActive={isPathActive}
            url={data.primary.url}
            iconClass={data.primary.iconClass}
            title={data.primary.title}
            commonUrl={data.commonUrl}
            child={data.secondary}
          />
        );
      })}
    </ul>
  </nav>

  );
};

export default Sidebar;
